module.exports = __webpack_public_path__ + "static/work-performance-0907afec87315ffc2fbc42b74baaa8a2.svg";